(function () {
  'use strict';

  var root = document.querySelector('[data-predictive-search]');
  if (!root || typeof window.fetch !== 'function') return;

  var input = root.querySelector('[data-predictive-search-input]');
  var results = root.querySelector('[data-predictive-search-results]');
  if (!input || !results) return;

  var timer = null;
  var controller = null;
  var activeIndex = -1;

  function routesRoot() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
  }

  function options() {
    return results.querySelectorAll('[data-predictive-search-option]');
  }

  function setExpanded(expanded) {
    input.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    results.hidden = !expanded;
    if (!expanded) {
      activeIndex = -1;
      input.removeAttribute('aria-activedescendant');
    }
  }

  function close() {
    setExpanded(false);
  }

  function setActive(index) {
    var items = options();
    if (!items.length) return;

    if (index < 0) index = items.length - 1;
    if (index >= items.length) index = 0;
    activeIndex = index;

    Array.prototype.forEach.call(items, function (item, itemIndex) {
      var option = item.closest('[role="option"]');
      var selected = itemIndex === activeIndex;
      if (option) option.setAttribute('aria-selected', selected ? 'true' : 'false');
      if (selected) {
        if (!item.id) item.id = 'PredictiveSearchOption-' + itemIndex;
        input.setAttribute('aria-activedescendant', item.id);
        item.scrollIntoView({ block: 'nearest' });
      }
    });
  }

  function render(text) {
    var doc = new DOMParser().parseFromString(text, 'text/html');
    var section = doc.querySelector('#shopify-section-predictive-search');
    if (!section) {
      close();
      return;
    }

    results.innerHTML = section.innerHTML;
    setExpanded(results.textContent.trim().length > 0);
  }

  function request(term) {
    if (controller) controller.abort();
    controller = typeof AbortController === 'function' ? new AbortController() : null;

    var url = routesRoot()
      + 'search/suggest?q=' + encodeURIComponent(term)
      + '&resources[type]=product&resources[limit]=6&section_id=predictive-search';

    fetch(url, {
      credentials: 'same-origin',
      signal: controller ? controller.signal : undefined
    })
      .then(function (response) {
        if (!response.ok) throw new Error(String(response.status));
        return response.text();
      })
      .then(render)
      .catch(function (error) {
        if (error && error.name === 'AbortError') return;
        close();
      });
  }

  input.addEventListener('input', function () {
    var term = input.value.trim();
    window.clearTimeout(timer);

    if (!term) {
      if (controller) controller.abort();
      results.innerHTML = '';
      close();
      return;
    }

    timer = window.setTimeout(function () {
      request(term);
    }, 250);
  });

  input.addEventListener('keydown', function (event) {
    if (input.getAttribute('aria-expanded') !== 'true') return;

    if (event.key === 'ArrowDown') {
      event.preventDefault();
      setActive(activeIndex + 1);
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      setActive(activeIndex - 1);
    } else if (event.key === 'Enter' && activeIndex >= 0) {
      var items = options();
      if (items[activeIndex]) {
        event.preventDefault();
        items[activeIndex].click();
      }
    } else if (event.key === 'Escape') {
      event.preventDefault();
      close();
    }
  });

  document.addEventListener('click', function (event) {
    if (!root.contains(event.target)) close();
  });
})();
